import {
  arrayOf, bool, func, shape, string
} from 'prop-types';

export const propTypes = {
  addedNValues: arrayOf(string).isRequired,
  breadcrumbs: arrayOf(shape({
    label: string,
    url: string,
    browseUrl: string,
    creativeIconUrl: string,
    deselectUrl: string,
    dimensionName: string,
    refinementKey: string
  })),
  itemId: string,
  selectedItemId: string,
  setAddedNValues: func.isRequired,
  ssr: bool,
  projectId: string
};

export const defaultProps = {
  breadcrumbs: [],
  itemId: '',
  selectedItemId: '',
  ssr: false,
  projectId: null
};

/* eslint-disable max-len */
/**
 * This function grabs all nested mycart iframes and checks to see which has the project shopping portal node rendered. An element is returned if one exists.
 * @param {string} selector ex: '#project-shopping-portal'
 * @returns HTMLElement
 */
export const querySelectorAllInIframes = (selector, fromBSSDrawer) => {
  let element;

  const recurse = (contentWindow = window) => {
    try {
      const iframes = contentWindow.document.body.querySelectorAll('iframe');
      iframes.forEach((iframe) => recurse(iframe.contentWindow));

      // if ATC not fired from bss, skip and look for another ATC drawer
      if (!fromBSSDrawer && contentWindow?.frameElement?.baseURI?.includes('/cart/bss')) {
        return null;
      }

      const selectedElement = contentWindow.document.body.querySelector(selector);
      if (selectedElement) {
        element = selectedElement;
      }
    } catch (error) {
      return null;
    }
    return null;
  };

  recurse();

  return element;
};